export * from '@taqueria/protocol/out/types/LoadedConfig';
